import { useState, useCallback } from 'react';
import supervisorWorkloadService from '../services/supervisorWorkloadService';
import i18n from '../i18n';

const useSupervisorWorkload = () => {
    const [items, setItems] = useState([]);
    const [total, setTotal] = useState(0);
    const [detail, setDetail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [detailLoading, setDetailLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchList = useCallback(async (params = {}) => {
        setLoading(true);
        setError(null);
        try {
            const res = await supervisorWorkloadService.getList(params);
            if (res.success) {
                setItems(Array.isArray(res.data?.items) ? res.data.items : []);
                setTotal(res.data?.total ?? 0);
            } else {
                setError(res.error);
            }
        } catch (err) {
            setError(err?.message || i18n.t('hookErrors.common.unexpected'));
        } finally {
            setLoading(false);
        }
    }, []);

    const fetchDetail = useCallback(async (supervisorId) => {
        setDetailLoading(true);
        setDetail(null);
        try {
            const res = await supervisorWorkloadService.getDetail(supervisorId);
            if (res.success) {
                setDetail(res.data);
            }
            return res;
        } catch (err) {
            setError(err?.message || i18n.t('hookErrors.common.unexpected'));
        } finally {
            setDetailLoading(false);
        }
    }, []);

    const clearDetail = useCallback(() => setDetail(null), []);

    return { items, total, detail, loading, detailLoading, error, fetchList, fetchDetail, clearDetail };
};

export default useSupervisorWorkload;
